import {
  currentFeed,
  feedSections,
  feedToReturnTo,
} from 'src/components/navigation/feeds.js'
import {
  filterNavigation,
  getBookmarkEntries,
  getFollowedTagEntries,
  getListEntries,
} from 'src/components/navigation/filter.js'
import { TIMELINES } from 'src/components/navigation/navigation.js'

import { useBookmarkFoldersStore } from 'src/stores/bookmark_folders.js'
import { useFollowedTagsStore } from 'src/stores/followed_tags.js'
import { useInstanceCapabilitiesStore } from 'src/stores/instance_capabilities.js'
import { useInterfaceStore } from 'src/stores/interface'
import { useListsStore } from 'src/stores/lists.js'
import { useSyncConfigStore } from 'src/stores/sync_config.js'
import { useUsersStore } from 'src/stores/users.js'

// The feed menu's sections, read from the stores (call it in a computed):
// one source for the menu and the pinned feeds in the header
export const storeFeedSections = () =>
  feedSections({
    timelines: filterNavigation(
      Object.entries(TIMELINES).map(([name, item]) => ({ ...item, name })),
    ),
    lists: getListEntries(useListsStore()),
    tags: getFollowedTagEntries(useFollowedTagsStore().tags),
    bookmarks: getBookmarkEntries(useBookmarkFoldersStore()),
    loggedIn: !!useUsersStore().currentUser,
    bookmarkFolders:
      useInstanceCapabilitiesStore().pleromaBookmarkFoldersAvailable,
    // a pinned one too: its pin can be taken off
    hasBookmarks:
      useBookmarkFoldersStore().hasBookmarks ||
      pinnedNames().includes('bookmarks'),
  })

// what the sections need beyond the stores that load at login: the
// followed hashtags and whether anything is bookmarked (once each)
export const loadFeedData = () => {
  if (!useUsersStore().currentUser) return
  useFollowedTagsStore().ensureLoaded()
  useBookmarkFoldersStore().checkBookmarks()
}

const PINS = 'collections.pinnedNavItems'

// the names of the pinned feeds (the synced setting; it can hold others)
export const pinnedNames = () =>
  useSyncConfigStore().prefsStorage.collections.pinnedNavItems

export const togglePin = (name) => {
  const store = useSyncConfigStore()
  if (pinnedNames().includes(name)) {
    store.removeCollectionPreference({ path: PINS, value: name })
  } else {
    store.addCollectionPreference({ path: PINS, value: name })
  }
  store.pushSyncConfig()
}

// list titles and folder names, for currentFeed
export const feedNames = {
  listTitle: (id) => useListsStore().findListTitle(id),
  folderName: (id) => useBookmarkFoldersStore().findBookmarkFolderName(id),
  listEmoji: (id) => useListsStore().findListEmoji(id),
  folderEmoji: (id) => useBookmarkFoldersStore().findBookmarkFolderEmoji(id),
}

// on each route change: a feed on screen becomes the one to go back to
export const rememberFeed = (route) => {
  const feed = currentFeed(route, feedNames)
  if (feed) useInterfaceStore().setLastTimeline(feed.route)
}

// "‹" on a page: back where you came from; opened from a link (no page of
// the app before it in the history), to the feed
export const goBackOrToFeed = (router) => {
  if (window.history.state?.back) return router.back()
  router.push(
    feedToReturnTo(
      useInterfaceStore().lastTimeline,
      !!useUsersStore().currentUser,
    ),
  )
}
